export default __webpack_public_path__ + "static/media/event-banner-1.be84c5a6.svg";